
export function isInternalPath(href: string): boolean {
  if (!href.startsWith('/')) return false;
  const rest = href.slice(1);
  if (rest.startsWith('/') || rest.startsWith('\\')) return false;
  if (/^%2f/i.test(rest) || /^%5c/i.test(rest)) return false;
  for (const ch of href) {
    if (ch.charCodeAt(0) <= 0x20) return false;
  }
  return true;
}

export function sameOriginPath(href: string): string | null {
  if (isInternalPath(href)) return href;
  if (typeof window === 'undefined') return null;
  let url: URL;
  try {
    url = new URL(href, window.location.origin);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin) return null;
  const path = `${url.pathname}${url.search}${url.hash}`;
  return isInternalPath(path) ? path : null;
}
